import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAumyeState } from '../states/aumye.state';
import * as fromDashboardActions from '../actions/dashboard.action';
import * as fromAssetsActions from '../actions/assets.actions';
import * as fromAnalyticsActions from '../actions/analytics.actions';
import * as fromUserProfileActions from '../actions/user-profile.actions';
import * as fromAdvancedSoSActions from '../actions/advanced_sos.actions';
import * as fromManageUserActions from '../actions/manage-user.action';
import { catchError, mergeMap, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { Router } from '@angular/router';
import { AumyeDashboardService } from 'src/app/services/aumye-dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { LoadingDashboardDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/loading-dashboard-dialog/loading-dashboard-dialog.component';
import { AumyeSecurityGuardService } from 'src/app/services/aumye-security-guard.service';
import { AumyeFirebaseRealtimeDbService } from 'src/app/services/realTimeData/aumye-firebase-realtime-db.service';
import { SendReportsEmailDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/send-reports-email-dialog/send-reports-email-dialog.component';
import { PleaseWaitDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/please-wait-dialog/please-wait-dialog.component';
import { AumyeEmergencyLocationService } from 'src/app/services/aumye-emergency-location.service';
import { Capacitor } from '@capacitor/core';
import { TokenExpiredDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/token-expired-dialog/token-expired-dialog.component';
import { EmployeeAttendanceResponseDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/employee-attendance-response-dialog/employee-attendance-response-dialog.component';
import { SimulationService } from 'src/app/services/simulation/simulation.service';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { LocationSosService } from 'src/app/services/geofence/location-sos.service';

@Injectable()
export class CyclopsDashboardEffects {
  encryptedData = localStorage.getItem('UserDetails');
  userRole: string = null;
  orgid: string = null;
  userId: string = null;
  decryptedUserData: any;
  constructor(
    private actions$: Actions,
    private store: Store<IAumyeState>,
    private dashboardService: AumyeDashboardService,
    private securityGuardService: AumyeSecurityGuardService,
    private router: Router, // private authenticationService: AumyeAuthenticationService
    private toastr: ToastrService,
    private dialog: MatDialog,
    private aumyeFirebaseRealtimeDbService: AumyeFirebaseRealtimeDbService,
    private aumyeEmergencyLocationService: AumyeEmergencyLocationService,
    private simulationService: SimulationService,
    private encryptionService: EncryptionService,
    private locationSosService: LocationSosService
  ) {
    if (this.encryptedData == null) {
      this.encryptedData = localStorage.getItem('UserDetails');
    }
    if (this.encryptedData != null) {
      this.decryptedUserData = this.encryptionService.decrypt(
        this.encryptedData
      );
      this.userRole = this.decryptedUserData.Role;
      this.orgid = this.decryptedUserData.OrganizationID;
      this.userId = this.decryptedUserData.UserID;
    }
  }

  InitDashboard$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitDashboard>(
          fromDashboardActions.DashboardActionTypes.INIT_DASHBOARD
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap((data) => {
          let {
            state: {
              status: {
                isDashboardDataLoaded,
                isPushNotificationTokenRegistered,
              },
            },
          } = data;
          if (this.orgid == null && !this.decryptedUserData) {
            this.encryptedData = localStorage.getItem('UserDetails');

            if (this.encryptedData != null) {
              this.decryptedUserData = this.encryptionService.decrypt(
                this.encryptedData
              );
              this.userRole = this.decryptedUserData.Role;
              this.orgid = this.decryptedUserData.OrganizationID;
              this.userId = this.decryptedUserData.UserID;
            } else {
              window.alert('Org ID is empty');
            }
          }

          if (this.orgid != '766773b7-51e9-4951-a2de-6245e6233758') {
            const isDevice: boolean = this.userRole === 'device';
            const isKiosk: boolean = this.userRole === 'kiosk';
            this.locationSosService.initializeUser();
            if (isDevice) this.router.navigateByUrl('/dashboard/employee');
            // else if (isKiosk) this.router.navigateByUrl('/dashboard/guard');
            else {
              if (!isDashboardDataLoaded) {
                this.store.dispatch(
                  new fromDashboardActions.GetDashboardData({})
                );
              }
              if (!isPushNotificationTokenRegistered) {
                setTimeout(() => {
                  this.store.dispatch(
                    new fromDashboardActions.SaveAppToken({})
                  );
                }, 3000);
              }

              setTimeout(() => {
                this.aumyeEmergencyLocationService.updateLocation(10000);
                this.aumyeEmergencyLocationService.autoRemoveInActiveUser();
              }, 1000);
              this.router.navigateByUrl('dashboard');
            }
          } else {
            let isInit = localStorage.getItem('IsQuestionsAnswered');
            if (isInit == 'true') {
              setTimeout(() => {
                this.store.dispatch(
                  new fromDashboardActions.InitDashboardSim({})
                );
              }, 2000);
              setTimeout(() => {
                this.aumyeEmergencyLocationService.updateLocation(
                  5 * 60 * 1000
                );
              }, 1000);
            }

            this.router.navigateByUrl('dashboard');
          }
        })
      ),
    { dispatch: false }
  );
  isSimulationStarted = false;
  InitDashboardSim$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitDashboardSim>(
          fromDashboardActions.DashboardActionTypes.INIT_SIMULATION
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(
          ({
            state: {
              status: { isSimulationStarted },
            },
          }) => {
            this.aumyeEmergencyLocationService.clearFirebaseData();
            this.simulationService.onCreateOrgUsers();
            this.simulationService.onCreateProperties();

            if (!this.isSimulationStarted) {
              //INTRUSION
              this.simulationService.onInitIntrusion();

              //THEFT
              this.simulationService.onCreateManualRobberyIncident();

              //RIOT/PROTEST
              setTimeout(() => {
                this.simulationService.onCreateManualRiotIncident(
                  `Around 100-150 peoples were seen gathering around the boy's mess hall`
                );
              }, 45 * 1000); //45 Seconds
              setTimeout(() => {
                this.simulationService.onCreateManualRiotIncident(
                  `Possible mass protest in around balcony area`
                );
              }, 2 * 1000 * 60); //2 minutes

              //FIRE
              this.simulationService.onCreateFireIncident();

              //Device Failure
              this.simulationService.onCreateDeviceFailure();

              //Anpr
              this.simulationService.onCreateAnprIncident();

              //Face
              this.simulationService.onCreateFaceIncident();

              //Advanced SOS
              this.simulationService.onCreateSOSIncident();

              //Update Incident Status
              this.simulationService.onChangeIncidentStatus();

              //Update Incident ASsignee
              this.simulationService.onChangeIncidentAssignee();

              //Analytics
              this.simulationService.onInitRiskData();

              //Service Request
              this.simulationService.onCreateServiceRequest();
              setTimeout(() => {
                //Update Request Status
                this.simulationService.onUpdateRequest();
              }, 3000);

              setInterval(() => {
                this.simulationService.onRespondSoSRequest();
              }, 62 * 1000);

              this.isSimulationStarted = true;
            }
          }
        )
      ),
    { dispatch: false }
  );
  InitEmplopyee$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitEmplopyee>(
          fromDashboardActions.DashboardActionTypes.INIT_EMPLOYEE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap((data) => {
          this.router.navigateByUrl('dashboard/employee');
        })
      ),
    { dispatch: false }
  );

  InitAssetsTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitAssetsTab>(
          fromDashboardActions.DashboardActionTypes.INIT_ASSETS_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.store.dispatch(new fromAssetsActions.InitPropertyWall({}));
          this.router.navigateByUrl('dashboard/assets');
        })
      ),
    { dispatch: false }
  );
  InitSecurityAdvanced$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitSecurityAdvanced>(
          fromDashboardActions.DashboardActionTypes.INIT_SECURITY_ADVANCED
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.router.navigateByUrl('dashboard/emergency');
        })
      ),
    { dispatch: false }
  );
  InitManageUserTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitManageUserTab>(
          fromDashboardActions.DashboardActionTypes.INIT_MANAGE_USER_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ state }) => {
          // this.store.dispatch(new fromDashboardActions.SetContextData({}));
          this.router.navigateByUrl('dashboard/manageuser');
        })
      ),
    { dispatch: false }
  );
  InitReportsTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitReportsTab>(
          fromDashboardActions.DashboardActionTypes.INIT_REPORTS_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap((data) => {
          this.router.navigateByUrl('dashboard');
        })
      ),
    { dispatch: false }
  );
  InitAnalyticsTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitAnalyticsTab>(
          fromDashboardActions.DashboardActionTypes.INIT_ANALYTICS_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap((data) => {
          this.store.dispatch(
            new fromAnalyticsActions.InitAnalyticsTab(data.state)
          );
          this.router.navigateByUrl('dashboard/analytics');
        })
      ),
    { dispatch: false }
  );
  InitCalendarTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitCalendarTab>(
          fromDashboardActions.DashboardActionTypes.INIT_CALENDAR_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ state }) => {
          // this.store.dispatch(new fromDashboardActions.SetContextData({}));
          this.router.navigateByUrl('dashboard/calendar');
        })
      ),
    { dispatch: false }
  );
  InitMediaWallTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitCalendarTab>(
          fromDashboardActions.DashboardActionTypes.INIT_MEDIA_WALL_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ state }) => {
          // this.store.dispatch(new fromDashboardActions.SetContextData({}));
          this.router.navigateByUrl('dashboard/media');
        })
      ),
    { dispatch: false }
  );
  InitUserProfile$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitUserProfile>(
          fromDashboardActions.DashboardActionTypes.INIT_USER_PROFILE_SETTING
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.store.dispatch(
            new fromUserProfileActions.GetUserDetails(this.userId)
          );
          this.router.navigateByUrl('dashboard/profile');
        })
      ),
    { dispatch: false }
  );
  InitVisitorGateEntry$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitVisitorGateEntry>(
          fromDashboardActions.DashboardActionTypes.INIT_VISITOR_GATE_ENTRY_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ state }) => {})
      ),
    { dispatch: false }
  );
  GetDashboardData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetDashboardData>(
        fromDashboardActions.DashboardActionTypes.GET_DASHBOARD_DATA
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      tap(({}) => {
        const dialogRef = this.dialog.open(LoadingDashboardDialogComponent, {
          disableClose: true,
          data: {
            isFailed: false,
          },
        });
      }),
      switchMap(() => {
        return this.dashboardService.onGetDashboardData().pipe(
          mergeMap((res: any) => {
            res.incidentData = lowerCaseFirstLetterOfKeys(
              this.encryptionService.decrypt(res.incidentData)
            );
            res.orgUsersData = lowerCaseFirstLetterOfKeys(
              this.encryptionService.decrypt(res.orgUsersData)
            );
            res.visitorData = lowerCaseFirstLetterOfKeys(
              this.encryptionService.decrypt(res.visitorData)
            );
            res.orgSettingData = lowerCaseFirstLetterOfKeys(
              this.encryptionService.decrypt(res.orgSettingData)
            );
            res['userId'] = this.userId;
            return of(new fromDashboardActions.GetDashboardDataSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetDashboardDataFailure(err))
          )
        );
      })
    )
  );
  GetDashboardDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetDashboardDataSuccess>(
          fromDashboardActions.DashboardActionTypes.GET_DASHBOARD_DATA_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(
          ({
            state: {
              status: { isAssetsLoaded },
              orgUserList,
            },
          }) => {
            // const loggedUser = orgUserList.filter(
            //   (x) => x.userId.toLowerCase() === this.userId.toLowerCase()
            // )[0];
            // localStorage.setItem('IsEmployee', loggedUser?.isEmployee);
            // localStorage.setItem(
            //   'Department',
            //   loggedUser?.isEmployee === 'true'
            //     ? loggedUser.employeeDepartment
            //     : 'none'
            // );
            // localStorage.setItem('UserLocation', loggedUser.userLocation);
            this.dialog.closeAll();
            this.toastr.success('Loading Success', 'Dashboard', {
              closeButton: true,
              timeOut: 1500,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            });
            if (
              this.userRole !== 'security' &&
              this.userRole != 'housekeeping'
            ) {
              this.store.dispatch(
                new fromDashboardActions.GetUserInventory({})
              );
              this.store.dispatch(
                new fromDashboardActions.GetUserEventsList({})
              );
              if (!isAssetsLoaded)
                this.store.dispatch(new fromDashboardActions.LoadAllAssets({}));
            }
            this.store.dispatch(
              new fromDashboardActions.GetComplaintsTickets({})
            );
            this.store.dispatch(new fromDashboardActions.GetClaimTickets({}));
            this.store.dispatch(
              new fromDashboardActions.GetRequestsTickets({})
            );
          }
        )
      ),
    { dispatch: false }
  );
  GetDashboardDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetDashboardDataFailure>(
          fromDashboardActions.DashboardActionTypes.GET_DASHBOARD_DATA_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.dialog.closeAll();
          if (payload.status === 401) {
            this.toastr.error('Access Token Expired', 'Authentication Failed', {
              closeButton: false,
              timeOut: 5000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: false,
            });
            const dialogRef = this.dialog.open(TokenExpiredDialogComponent, {
              disableClose: true,
              backdropClass: 'session-backdrop',
            });
            setTimeout(() => {
              this.store.dispatch(
                new fromDashboardActions.UserLogout({ isExpired: true })
              );
            }, 1000);
          } else {
            this.toastr.error('API Failure', 'Error!', {
              closeButton: false,
              timeOut: 2000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: false,
            });
          }

          // const dialogRef = this.dialog.open(LoadingDashboardDialogComponent, {
          //   disableClose: true,
          //   data: {
          //     isFailed: true,
          //   },
          // });
          // dialogRef.afterClosed().subscribe((result: string) => {
          //   if (result) {
          //     this.store.dispatch(
          //       new fromDashboardActions.GetVisitorTabData({})
          //     );
          //   }
          // });
        })
      ),
    { dispatch: false }
  );
  GetVisitorTabData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetVisitorTabData>(
        fromDashboardActions.DashboardActionTypes.GET_VISITOR_TAB_DATA
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(() => {
        return this.dashboardService.onGetVisitorTabData().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetVisitorTabDataSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetVisitorTabDataFailure(err))
          )
        );
      })
    )
  );
  GetRangedIncidentData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetRangedIncidentData>(
        fromDashboardActions.DashboardActionTypes.GET_RANGED_INCIDENT_DATA
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetRangedIncidentTabData(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.GetRangedIncidentDataSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetRangedIncidentDataFailure(err))
          )
        );
      })
    )
  );
  GetRangedIncidentDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetRangedIncidentDataSuccess>(
          fromDashboardActions.DashboardActionTypes
            .GET_RANGED_INCIDENT_DATA_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.success('Success', 'Incident Data', {
            closeButton: true,
            timeOut: 2500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  GetRangedVisitorTabData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetRangedVisitorData>(
        fromDashboardActions.DashboardActionTypes.GET_RANGED_VISITOR_DATA
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetRangedVisitorTabData(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.GetRangedVisitorDataSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetRangedVisitorDataFailure(err))
          )
        );
      })
    )
  );
  GetRangedVisitorDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetRangedVisitorDataFailure>(
          fromDashboardActions.DashboardActionTypes
            .GET_RANGED_VISITOR_DATA_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.error('Failed', 'Visitor Data', {
            closeButton: true,
            timeOut: 2500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  GetRangedVisitorDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetRangedVisitorDataSuccess>(
          fromDashboardActions.DashboardActionTypes
            .GET_RANGED_VISITOR_DATA_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.success('Success', 'Visitor Data', {
            closeButton: true,
            timeOut: 2500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  GetVisitorTabDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetVisitorTabDataSuccess>(
          fromDashboardActions.DashboardActionTypes.GET_VISITOR_TAB_DATA_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ state }) => {
          // this.dialog.closeAll();
          let {
            status: { isIncidentDataLoaded },
          } = state;
          if (!isIncidentDataLoaded)
            this.store.dispatch(
              new fromDashboardActions.GetIncidentTabData({})
            );
        })
      ),
    { dispatch: false }
  );
  GetVisitorTabDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetVisitorTabDataFailure>(
          fromDashboardActions.DashboardActionTypes.GET_VISITOR_TAB_DATA_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.toastr.error('Visitor Data Failed');
          this.dialog.closeAll();
          // const dialogRef = this.dialog.open(LoadingDashboardDialogComponent, {
          //   disableClose: true,
          //   data: {
          //     isFailed: true,
          //   },
          // });
          // dialogRef.afterClosed().subscribe((result: string) => {
          //   if (result) {
          //     this.store.dispatch(
          //       new fromDashboardActions.GetVisitorTabData({})
          //     );
          //   }
          // });
        })
      ),
    { dispatch: false }
  );
  InitSettingsTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitSettingsTab>(
          fromDashboardActions.DashboardActionTypes.INIT_SETTINGS_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(
          ({
            state: {
              status: { isDashboardDataLoaded },
            },
          }) => {
            if (!isDashboardDataLoaded) {
              this.store.dispatch(new fromDashboardActions.GetOrgSettings({}));
            }
            this.router.navigateByUrl('dashboard/settings');
          }
        )
      ),
    { dispatch: false }
  );
  InitSecurityGuardTab$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.InitSecurityGuardTab>(
          fromDashboardActions.DashboardActionTypes.INIT_SECURITY_GUARD_TAB
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.router.navigateByUrl('dashboard/guard');
        })
      ),
    { dispatch: false }
  );
  onUserLogout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UserLogout>(
          fromDashboardActions.DashboardActionTypes.USER_LOGOUT
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          if (payload && payload?.isExpired) {
            this.store.dispatch(
              new fromDashboardActions.RemoveAppToken({
                orgId: this.orgid,
                userId: this.userId,
                userName: this.encryptionService.getCurrentUser().fullName,
              })
            );
          } else {
            this.store.dispatch(new fromDashboardActions.RemoveAppToken({}));
          }
        })
      ),
    { dispatch: false }
  );
  onRedirectingToLogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RedirectingToLogin>(
          fromDashboardActions.DashboardActionTypes.REDIRECTING_TO_LOGIN
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.router.navigate(['authentication/login']);
          window.location.reload();
        })
      ),
    { dispatch: false }
  );
  CheckExistingVisitor$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.CheckExistingVisitor>(
        fromDashboardActions.DashboardActionTypes.CHECK_EXISTING_VISITOR
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onCheckVisitorExists(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.CheckExistingVisitorSuccess(payload)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.CheckExistingVisitorFailure(err))
          )
        );
      })
    )
  );
  CheckExistingVisitorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CheckExistingVisitorSuccess>(
          fromDashboardActions.DashboardActionTypes
            .CHECK_EXISTING_VISITOR_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: payload }) => {
          this.store.dispatch(
            new fromDashboardActions.VisitorNotifyHost(payload.payload)
          );
        })
      ),
    { dispatch: false }
  );
  CheckExistingVisitorFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CheckExistingVisitorFailure>(
          fromDashboardActions.DashboardActionTypes
            .CHECK_EXISTING_VISITOR_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.error('Visitor Already Exists', 'Visitor', {
            closeButton: true,
            timeOut: 3500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  VisitorNotifyHost$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.VisitorNotifyHost>(
        fromDashboardActions.DashboardActionTypes.VISITOR_NOTIFY_HOST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap((data) => {
        let {
          action: { payload },
        } = data;
        return this.dashboardService.onVisitorNotifyHost(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.VisitorNotifyHostSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.VisitorNotifyHostFailure(err))
          )
        );
      })
    )
  );
  VisitorNotifyHostSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.VisitorNotifyHostSuccess>(
          fromDashboardActions.DashboardActionTypes.VISITOR_NOTIFY_HOST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('Success', 'Notify Host', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
          if (this.userRole === 'kiosk') {
            this.store.dispatch(new fromDashboardActions.InitDashboard({}));
          }
        })
      ),
    { dispatch: false }
  );
  VisitorNotifyHostFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.VisitorNotifyHostFailure>(
          fromDashboardActions.DashboardActionTypes.VISITOR_NOTIFY_HOST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error Notifying Host');
        })
      ),
    { dispatch: false }
  );
  HostStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.HostStatus>(
        fromDashboardActions.DashboardActionTypes.HOST_STATUS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap((data) => {
        let {
          action: { payload },
        } = data;
        return this.dashboardService.onCheckHostStatus(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.HostStatusSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.HostStatusFailure(err))
          )
        );
      })
    )
  );
  ClearVisitorEntry$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.ClearVisitorEntry>(
        fromDashboardActions.DashboardActionTypes.CLEAR_VISITOR_ENTRY
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap((data) => {
        let {
          action: { payload },
        } = data;
        return this.dashboardService.onClearVisitorEntry(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.ClearVisitorEntrySuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.ClearVisitorEntryFailure(err))
          )
        );
      })
    )
  );
  ClearVisitorEntrySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ClearVisitorEntrySuccess>(
          fromDashboardActions.DashboardActionTypes.CLEAR_VISITOR_ENTRY_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // //this.toastr.success('Clear Visitor Entry Success');
          this.dialog.closeAll();
          window.location.reload();
        })
      ),
    { dispatch: false }
  );
  ClearVisitorEntryFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ClearVisitorEntryFailure>(
          fromDashboardActions.DashboardActionTypes.CLEAR_VISITOR_ENTRY_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Clear Visitor Entry Failed');
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  GetIncidentTabData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetIncidentTabData>(
        fromDashboardActions.DashboardActionTypes.GET_INCIDENT_TAB_DATA
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),

      switchMap(() => {
        return this.dashboardService.onGetIncidentTabData().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetIncidentTabDataSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetIncidentTabDataFailure(err))
          )
        );
      })
    )
  );
  GetIncidentTabDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetIncidentTabDataSuccess>(
          fromDashboardActions.DashboardActionTypes
            .GET_INCIDENT_TAB_DATA_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(
          ({
            state: {
              status: { isOrgUserDetailsLoaded },
            },
          }) => {
            if (!isOrgUserDetailsLoaded)
              this.store.dispatch(new fromDashboardActions.GetUserList({}));
          }
        )
      ),
    { dispatch: false }
  );
  GetIncidentTabDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetIncidentTabDataFailure>(
          fromDashboardActions.DashboardActionTypes
            .GET_INCIDENT_TAB_DATA_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Incident Data Failed');
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(LoadingDashboardDialogComponent, {
            disableClose: false,
            data: {
              isFailed: true,
            },
          });
          dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {
              this.store.dispatch(
                new fromDashboardActions.GetIncidentTabData({})
              );
            }
          });
        })
      ),
    { dispatch: false }
  );
  GetUserList$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetUserList>(
        fromDashboardActions.DashboardActionTypes.GET_USER_LIST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      tap(({}) => {}),
      switchMap(() => {
        return this.dashboardService.onGetOrgUserList().pipe(
          mergeMap((res: any) => {
            res['userId'] = this.userId;
            return of(new fromDashboardActions.GetUserListSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetUserListFailure(err))
          )
        );
      })
    )
  );
  GetUserListSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetUserListSuccess>(
          fromDashboardActions.DashboardActionTypes.GET_USER_LIST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(
          ({
            state: {
              status: { isAssetsLoaded },
            },
          }) => {
            if (
              this.userRole !== 'security' &&
              this.userRole != 'housekeeping'
            ) {
              if (!isAssetsLoaded) {
                this.store.dispatch(new fromDashboardActions.LoadAllAssets({}));
              }
            }
          }
        )
      ),
    { dispatch: false }
  );
  GetUserListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetUserListFailure>(
          fromDashboardActions.DashboardActionTypes.GET_USER_LIST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('User List Failed');
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(LoadingDashboardDialogComponent, {
            disableClose: true,
            data: {
              isFailed: true,
            },
          });
          dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {
              this.store.dispatch(new fromDashboardActions.GetUserList({}));
            }
          });
        })
      ),
    { dispatch: false }
  );
  LoadAllAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.LoadAllAssets>(
        fromDashboardActions.DashboardActionTypes.LOAD_ALL_ASSETS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(() => {
        return this.dashboardService.onGetOrgAssetsList().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.LoadAllAssetsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.LoadAllAssetsFailure(err))
          )
        );
      })
    )
  );

  LoadAllAssetsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.LoadAllAssetsSuccess>(
          fromDashboardActions.DashboardActionTypes.LOAD_ALL_ASSETS_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(() => {
          let isDeepLink = localStorage.getItem('IsLink');
          if (isDeepLink == 'false') {
            if (
              this.userRole !== 'security' &&
              this.userRole != 'housekeeping'
            ) {
              this.store.dispatch(
                new fromDashboardActions.GetNoticeBoardPosts({})
              );
              this.store.dispatch(new fromDashboardActions.ManageUserPolls({}));
              this.store.dispatch(
                new fromDashboardActions.GetNumberPlatesList({})
              );
            }
          }
        })
      ),
    { dispatch: false }
  );
  LoadAllAssetsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.LoadAllAssetsFailure>(
          fromDashboardActions.DashboardActionTypes.LOAD_ALL_ASSETS_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Assets Load Failed');
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(LoadingDashboardDialogComponent, {
            disableClose: true,
            data: {
              isFailed: true,
            },
          });
          dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {
              this.store.dispatch(new fromDashboardActions.LoadAllAssets({}));
            }
          });
        })
      ),
    { dispatch: false }
  );

  CreateManualIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.CreateManualIncident>(
        fromDashboardActions.DashboardActionTypes.CREATE_MANUAL_INCIDENT
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap((data) => {
        let {
          action: { payload },
        } = data;
        return this.dashboardService.onCreateManualEvent(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.CreateManualIncidentSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.CreateManualIncidentFailure(err))
          )
        );
      })
    )
  );
  CreateManualIncidentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CreateManualIncidentSuccess>(
          fromDashboardActions.DashboardActionTypes
            .CREATE_MANUAL_INCIDENT_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('Success', 'Manual Incident', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          // this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
        })
      ),
    { dispatch: false }
  );
  CreateManualIncidentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CreateManualIncidentFailure>(
          fromDashboardActions.DashboardActionTypes
            .CREATE_MANUAL_INCIDENT_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Event Create Failed');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  pleaseWaitDialog: any;
  VerifyIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.VerifyIncident>(
        fromDashboardActions.DashboardActionTypes.VERIFY_INCIDENT
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      tap(() => {
        this.pleaseWaitDialog = this.dialog.open(PleaseWaitDialogComponent, {
          disableClose: true,
        });
      }),
      switchMap((data) => {
        return this.dashboardService.onVerifyIncident(data.action.payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.VerifyIncidentSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.VerifyIncidentFailure(err))
          )
        );
      })
    )
  );
  VerifyIncidentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.VerifyIncidentSuccess>(
          fromDashboardActions.DashboardActionTypes.VERIFY_INCIDENT_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.pleaseWaitDialog.close();
          // this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
          // this.store.dispatch(
          //   new fromDashboardActions.GetComplaintsTickets({})
          // );
          // this.toastr.success('Verify Incident Success');
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  VerifyIncidentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.VerifyIncidentFailure>(
          fromDashboardActions.DashboardActionTypes.VERIFY_INCIDENT_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Verify Incident Failed');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  SnoozeIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SnoozeIncident>(
        fromDashboardActions.DashboardActionTypes.SNOOZE_INCIDENT
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap((data) => {
        return this.dashboardService.onSnoozeIncident(data.action.payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SnoozeIncidentSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SnoozeIncidentFailure(err))
          )
        );
      })
    )
  );
  SnoozeIncidentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SnoozeIncidentSuccess>(
          fromDashboardActions.DashboardActionTypes.SNOOZE_INCIDENT_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // //this.toastr.success('Snooze Incident Success');
          // this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
          // this.store.dispatch(
          //   new fromDashboardActions.GetComplaintsTickets({})
          // );
        })
      ),
    { dispatch: false }
  );
  SnoozeIncidentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SnoozeIncidentFailure>(
          fromDashboardActions.DashboardActionTypes.SNOOZE_INCIDENT_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Snooze Incident Failed');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  UpdateVisitorList$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateVisitorList>(
        fromDashboardActions.DashboardActionTypes.UPDATE_VISITOR_LIST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(() => {
        return this.dashboardService.onGetVisitorTabData().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.UpdateVisitorListSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateVisitorListFailure(err))
          )
        );
      })
    )
  );
  UpdateIncidentList$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateIncidentList>(
        fromDashboardActions.DashboardActionTypes.UPDATE_INCIDENT_LIST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(() => {
        return this.dashboardService.onGetIncidentTabData().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.UpdateIncidentListSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateIncidentListFailure(err))
          )
        );
      })
    )
  );
  UpdateIncidentListSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateIncidentListSuccess>(
          fromDashboardActions.DashboardActionTypes.UPDATE_INCIDENT_LIST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          // //this.toastr.success('Incident Data Refreshed');
        })
      ),
    { dispatch: false }
  );
  UpdateIncidentListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateIncidentListFailure>(
          fromDashboardActions.DashboardActionTypes.UPDATE_INCIDENT_LIST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.error('Incident Data Refresh Failed');
        })
      ),
    { dispatch: false }
  );

  RemoveIncidentById$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RemoveIncidentById>(
          fromDashboardActions.DashboardActionTypes.REMOVE_INCIDENT_BY_ID
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.dialog.closeAll();
          if (payload && payload?.MessageBody && payload?.MessageTitle) {
            this.toastr.success(payload.MessageBody, payload.MessageTitle, {
              closeButton: true,
              timeOut: 5000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            });
          }
        })
      ),
    { dispatch: false }
  );

  RemoveServiceById$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RemoveServiceById>(
          fromDashboardActions.DashboardActionTypes.REMOVE_SERVICE_BY_ID
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.dialog.closeAll();
          if (payload && payload?.MessageBody && payload?.MessageTitle) {
            this.toastr.success(
              payload.MessageBody.replace('incident', 'service request'),
              payload.MessageTitle.replace(/incident/gi, 'Service request'),
              {
                closeButton: true,
                timeOut: 5000,
                progressBar: true,
                enableHtml: true,
                tapToDismiss: true,
              }
            );
          }
        })
      ),
    { dispatch: false }
  );
  RemoveClaimsById$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RemoveClaimsById>(
          fromDashboardActions.DashboardActionTypes.REMOVE_CLAIMS_BY_ID
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.dialog.closeAll();
          if (payload && payload?.MessageBody && payload?.MessageTitle) {
            this.toastr.success(
              payload.MessageBody.replace('incident', 'claim'),
              payload.MessageTitle.replace(/incident/gi, 'Claim'),
              {
                closeButton: true,
                timeOut: 5000,
                progressBar: true,
                enableHtml: true,
                tapToDismiss: true,
              }
            );
          }
        })
      ),
    { dispatch: false }
  );
  RemoveComplaintsById$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RemoveComplaintsById>(
          fromDashboardActions.DashboardActionTypes.REMOVE_COMPLAINTS_BY_ID
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.dialog.closeAll();
          if (payload && payload?.MessageBody && payload?.MessageTitle) {
            this.toastr.success(
              payload.MessageBody.replace('incident', 'complaint'),
              payload.MessageTitle.replace(/incident/gi, 'Complaint'),
              {
                closeButton: true,
                timeOut: 5000,
                progressBar: true,
                enableHtml: true,
                tapToDismiss: true,
              }
            );
          }
        })
      ),
    { dispatch: false }
  );
  GetNumberPlatesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetNumberPlatesList>(
        fromDashboardActions.DashboardActionTypes.GET_NUMBER_PLATES_LIST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(() => {
        return this.dashboardService.onGetOrgNumberPlateList().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetNumberPlatesListSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetNumberPlatesListFailure(err))
          )
        );
      })
    )
  );
  GetNumberPlatesListSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetNumberPlatesListSuccess>(
          fromDashboardActions.DashboardActionTypes
            .GET_NUMBER_PLATES_LIST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          //this.toastr.success('Incident Data Refreshed');
        })
      ),
    { dispatch: false }
  );
  GetFaceTimeline$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetFaceTimeline>(
        fromDashboardActions.DashboardActionTypes.GET_FACE_TIMELINE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(() => {
        return this.dashboardService.onGetFaceTime().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetFaceTimelineSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetFaceTimelineFailure(err))
          )
        );
      })
    )
  );
  GetIncidentEvidence$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetIncidentEvidence>(
        fromDashboardActions.DashboardActionTypes.GET_INCIDENT_EVIDENCE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetEvidence(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetIncidentEvidenceSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetIncidentEvidenceFailure(err))
          )
        );
      })
    )
  );
  LodgeUserComplain$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.LodgeUserComplain>(
        fromDashboardActions.DashboardActionTypes.LODGE_USER_COMPLAINT
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onLodgeUserComplains(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.LodgeUserComplainSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.LodgeUserComplainFailure(err))
          )
        );
      })
    )
  );
  LodgeUserComplainSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.LodgeUserComplainSuccess>(
          fromDashboardActions.DashboardActionTypes.LODGE_USER_COMPLAINT_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // //this.toastr.success('Registered your complain!');.(
          // this.store.dispatch(new fromDashboardActions.GetIncidentTabData({}));
          // this.store.dispatch(
          //   new fromDashboardActions.GetComplaintsTickets({})
          // );
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  LodgeUserComplainFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.LodgeUserComplainFailure>(
          fromDashboardActions.DashboardActionTypes.LODGE_USER_COMPLAINT_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Please try again!');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  SendBulkInvite$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SendBulkInvite>(
        fromDashboardActions.DashboardActionTypes.SEND_BULK_INVITE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onBulkSendInvitation(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SendBulkInviteSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SendBulkInviteFailure(err))
          )
        );
      })
    )
  );
  SendBulkInviteSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SendBulkInviteSuccess>(
          fromDashboardActions.DashboardActionTypes.SEND_BULK_INVITE_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // //this.toastr.success('Bulk Invitation Sent!');
          this.dialog.closeAll();
          this.store.dispatch(new fromDashboardActions.GetUserEventsList({}));
          this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
        })
      ),
    { dispatch: false }
  );
  SendBulkInviteFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SendBulkInviteFailure>(
          fromDashboardActions.DashboardActionTypes.SEND_BULK_INVITE_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Invitation Sending Failed');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  CreateNoticeBoardPost$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.CreateNoticeBoardPost>(
        fromDashboardActions.DashboardActionTypes.CREATE_NOTICE_BOARD_POST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onCreateNoticeBoardPost(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.CreateNoticeBoardPostSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.CreateNoticeBoardPostFailure(err))
          )
        );
      })
    )
  );
  CreateNoticeBoardPostSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CreateNoticeBoardPostSuccess>(
          fromDashboardActions.DashboardActionTypes
            .CREATE_NOTICE_BOARD_POST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
          //this.toastr.success('Created notice board post!');
          this.dialog.closeAll();
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  CreateNoticeBoardPostFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CreateNoticeBoardPostFailure>(
          fromDashboardActions.DashboardActionTypes
            .CREATE_NOTICE_BOARD_POST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  GetNoticeBoardPosts$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetNoticeBoardPosts>(
        fromDashboardActions.DashboardActionTypes.GET_NOTICE_BOARD_POSTS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      tap(({ action: { payload } }) => {
        if (payload && payload?.MessageBody && payload?.MessageTitle) {
          this.toastr.success(payload.MessageBody, payload.MessageTitle, {
            closeButton: true,
            timeOut: 5000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        }
      }),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetNoticeBoardPosts().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetNoticeBoardPostsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetNoticeBoardPostsFailure(err))
          )
        );
      })
    )
  );
  GetNoticeBoardPostsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetNoticeBoardPostsSuccess>(
          fromDashboardActions.DashboardActionTypes
            .GET_NOTICE_BOARD_POSTS_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  GetNoticeBoardPostsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetNoticeBoardPostsFailure>(
          fromDashboardActions.DashboardActionTypes
            .GET_NOTICE_BOARD_POSTS_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  PostUserComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.PostUserComment>(
        fromDashboardActions.DashboardActionTypes.POST_USER_COMMENT
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      tap(() => {
        this.pleaseWaitDialog = this.dialog.open(PleaseWaitDialogComponent, {
          disableClose: true,
        });
      }),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onPostUserComment(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.PostUserCommentSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.PostUserCommentFailure(err))
          )
        );
      })
    )
  );
  PostUserCommentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.PostUserCommentSuccess>(
          fromDashboardActions.DashboardActionTypes.POST_USER_COMMENT_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // //this.toastr.success('Get notice board post!');
          // this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
          // this.store.dispatch(new fromDashboardActions.GetIncidentTabData({}));
          // this.store.dispatch(new fromDashboardActions.GetVisitorTabData({}));
          //this.toastr.success('Post Comment Added!');
          this.dialog.closeAll();
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  PostUserCommentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.PostUserCommentFailure>(
          fromDashboardActions.DashboardActionTypes.POST_USER_COMMENT_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  PostUserLike$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.PostUserLike>(
        fromDashboardActions.DashboardActionTypes.POST_USER_LIKE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onPostUserLike(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.PostUserLikeSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.PostUserLikeFailure(err))
          )
        );
      })
    )
  );
  PostUserLikeSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.PostUserLikeSuccess>(
          fromDashboardActions.DashboardActionTypes.POST_USER_LIKE_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
        })
      ),
    { dispatch: false }
  );
  PostUserLikeFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.PostUserLikeFailure>(
          fromDashboardActions.DashboardActionTypes.POST_USER_LIKE_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );

  DeleteUserPermanently$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.DeleteUserPermanently>(
        fromDashboardActions.DashboardActionTypes.DELETE_USER_PERMANENTLY
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onRemoveUserPermanently(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.DeleteUserPermanentlySuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.DeleteUserPermanentlyFailure(err))
          )
        );
      })
    )
  );
  DeleteUserPermanentlySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.DeleteUserPermanentlySuccess>(
          fromDashboardActions.DashboardActionTypes
            .DELETE_USER_PERMANENTLY_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success(
            'Account data removed successfully',
            'Account Delete',
            {
              closeButton: true,
              timeOut: 2000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            }
          );
          setTimeout(() => {
            this.store.dispatch(new fromDashboardActions.UserLogout({}));
          }, 250);
        })
      ),
    { dispatch: false }
  );
  DeleteUserPermanentlyFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.DeleteUserPermanentlyFailure>(
          fromDashboardActions.DashboardActionTypes
            .DELETE_USER_PERMANENTLY_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.toastr.error(payload.global, 'Server Failure', {
            closeButton: true,
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );

  UpdateFlaggedPost$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateFlaggedPost>(
        fromDashboardActions.DashboardActionTypes.UPDATE_FLAGGED_POST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onUpdateFlaggedPost(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.UpdateFlaggedPostSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateFlaggedPostFailure(err))
          )
        );
      })
    )
  );
  UpdateFlaggedPostSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateFlaggedPostSuccess>(
          fromDashboardActions.DashboardActionTypes.UPDATE_FLAGGED_POST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('Action has been saved', 'Aumye Community', {
            closeButton: true,
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
        })
      ),
    { dispatch: false }
  );
  UpdateFlaggedPostFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateFlaggedPostFailure>(
          fromDashboardActions.DashboardActionTypes.UPDATE_FLAGGED_POST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.toastr.error(payload.global, 'Server Failure', {
            closeButton: true,
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  AcceptOrRejectPost$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AcceptOrRejectPost>(
        fromDashboardActions.DashboardActionTypes.ACCEPT_OR_REJECT_POST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onAcceptOrRejectPost(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.AcceptOrRejectPostSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AcceptOrRejectPostFailure(err))
          )
        );
      })
    )
  );
  AcceptOrRejectPostSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AcceptOrRejectPostSuccess>(
          fromDashboardActions.DashboardActionTypes
            .ACCEPT_OR_REJECT_POST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('Action has been saved', 'Aumye Community', {
            closeButton: true,
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
        })
      ),
    { dispatch: false }
  );
  AcceptOrRejectPostFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AcceptOrRejectPostFailure>(
          fromDashboardActions.DashboardActionTypes
            .ACCEPT_OR_REJECT_POST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.toastr.error(payload.global, 'Server Failure', {
            closeButton: true,
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  ReportCommunityPost$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.ReportCommunityPost>(
        fromDashboardActions.DashboardActionTypes.REPORT_POST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onReportCommunityPost(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.ReportCommunityPostSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.ReportCommunityPostFailure(err))
          )
        );
      })
    )
  );
  ReportCommunityPostSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ReportCommunityPostSuccess>(
          fromDashboardActions.DashboardActionTypes.REPORT_POST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('Post reported successfully', 'Community Post', {
            closeButton: true,
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
        })
      ),
    { dispatch: false }
  );
  ReportCommunityPostFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ReportCommunityPostFailure>(
          fromDashboardActions.DashboardActionTypes.REPORT_POST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.toastr.error(payload.global, 'Server Failure', {
            closeButton: true,
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );

  AddPreApprovedVisitor$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddPreApprovedVisitor>(
        fromDashboardActions.DashboardActionTypes.ADD_PRE_APPROVED_VISITOR
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onPreApprovedVisitor(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.AddPreApprovedVisitorSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddPreApprovedVisitorFailure(err))
          )
        );
      })
    )
  );
  AddPreApprovedVisitorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddPreApprovedVisitorSuccess>(
          fromDashboardActions.DashboardActionTypes
            .ADD_PRE_APPROVED_VISITOR_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
          this.toastr.success('Scheduled', 'Pre-Approved Visitor', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  AddPreApprovedVisitorFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddPreApprovedVisitorFailure>(
          fromDashboardActions.DashboardActionTypes
            .ADD_PRE_APPROVED_VISITOR_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  RapidScheduleVisitor$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.RapidScheduleVisitor>(
        fromDashboardActions.DashboardActionTypes.RAPID_SCHEDULE_VISITOR
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onRapidScheduleVisitor(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.RapidScheduleVisitorSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.RapidScheduleVisitorFailure(err))
          )
        );
      })
    )
  );
  RapidScheduleVisitorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RapidScheduleVisitorSuccess>(
          fromDashboardActions.DashboardActionTypes
            .RAPID_SCHEDULE_VISITOR_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
          //this.toastr.success('Rapid visitor Scheduled!');
          // this.toastr.success('Scheduled', 'Rapid Visitor', {
          //   closeButton: true,
          //   timeOut: 1500,
          //   progressBar: true,
          //   enableHtml: true,
          //   tapToDismiss: true,
          // });
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  RapidScheduleVisitorFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RapidScheduleVisitorFailure>(
          fromDashboardActions.DashboardActionTypes
            .RAPID_SCHEDULE_VISITOR_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  GetUserEventsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetUserEventsList>(
        fromDashboardActions.DashboardActionTypes.GET_USER_EVENTS_LIST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetUserEventsList(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetUserEventsListSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetUserEventsListFailure(err))
          )
        );
      })
    )
  );
  GetUserEventsListSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetUserEventsListSuccess>(
          fromDashboardActions.DashboardActionTypes.GET_USER_EVENTS_LIST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  GetUserEventsListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetUserEventsListFailure>(
          fromDashboardActions.DashboardActionTypes.GET_USER_EVENTS_LIST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  CreateUserPoll$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.CreateUserPoll>(
        fromDashboardActions.DashboardActionTypes.CREATE_USER_POLL
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onCreateUserPoll(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.CreateUserPollSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.CreateUserPollFailure(err))
          )
        );
      })
    )
  );
  CreateUserPollSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CreateUserPollSuccess>(
          fromDashboardActions.DashboardActionTypes.CREATE_USER_POLL_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          //this.toastr.success('Poll Created!');
          this.dialog.closeAll();
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  CreateUserPollFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.CreateUserPollFailure>(
          fromDashboardActions.DashboardActionTypes.CREATE_USER_POLL_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Please try again!');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  ManageUserPolls$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.ManageUserPolls>(
        fromDashboardActions.DashboardActionTypes.MANAGE_USER_POLL
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onManageOrgPolls().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.ManageUserPollsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.ManageUserPollsFailure(err))
          )
        );
      })
    )
  );
  ManageUserPollsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ManageUserPollsSuccess>(
          fromDashboardActions.DashboardActionTypes.MANAGE_USER_POLL_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.store.dispatch(new fromDashboardActions.GetUserPolls({}));
        })
      ),
    { dispatch: false }
  );
  GetUserPolls$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetUserPolls>(
        fromDashboardActions.DashboardActionTypes.GET_USER_POLL_LIST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetUserPolls().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetUserPollsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetUserPollsFailure(err))
          )
        );
      })
    )
  );
  GetUserPollsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetUserPollsSuccess>(
          fromDashboardActions.DashboardActionTypes.GET_USER_POLL_LIST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {})
      ),
    { dispatch: false }
  );
  GetUserPollsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetUserPollsFailure>(
          fromDashboardActions.DashboardActionTypes.GET_USER_POLL_LIST_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  SubmitPollResponse$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SubmitPollResponse>(
        fromDashboardActions.DashboardActionTypes.SUBMIT_POLL_RESPONSE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onSubmitPollResponse(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SubmitPollResponseSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SubmitPollResponseFailure(err))
          )
        );
      })
    )
  );
  SubmitPollResponseSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SubmitPollResponseSuccess>(
          fromDashboardActions.DashboardActionTypes.SUBMIT_POLL_RESPONSE_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.store.dispatch(new fromDashboardActions.GetUserPolls({}));
          //this.toastr.success('Response Saved');
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  SubmitPollResponseFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SubmitPollResponseFailure>(
          fromDashboardActions.DashboardActionTypes.SUBMIT_POLL_RESPONSE_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  UpdateVisitorDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateVisitorDetails>(
        fromDashboardActions.DashboardActionTypes.UPDATE_VISITOR_DETAILS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      tap(({}) => {
        this.dialog.open(PleaseWaitDialogComponent, {
          disableClose: true,
        });
      }),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onUpdateVisitorDetails(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.UpdateVisitorDetailsSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateVisitorDetailsFailure(err))
          )
        );
      })
    )
  );
  UpdateVisitorDetailsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateVisitorDetailsSuccess>(
          fromDashboardActions.DashboardActionTypes
            .UPDATE_VISITOR_DETAILS_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
        })
      ),
    { dispatch: false }
  );
  UpdateVisitorDetailsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateVisitorDetailsFailure>(
          fromDashboardActions.DashboardActionTypes
            .UPDATE_VISITOR_DETAILS_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  PreApprovedVisitorCheckout$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.PreApprovedVisitorCheckout>(
        fromDashboardActions.DashboardActionTypes.PRE_APPROVED_VISITOR_CHECKOUT
      ),
      switchMap((action) => {
        let { payload } = action;
        return this.securityGuardService.onVisitorCheckOut({ ...payload }).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.PreApprovedVisitorCheckoutSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.PreApprovedVisitorCheckoutFailure(err))
          )
        );
      })
    )
  );
  PreApprovedVisitorCheckoutSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.PreApprovedVisitorCheckoutSuccess>(
          fromDashboardActions.DashboardActionTypes
            .PRE_APPROVED_VISITOR_CHECKOUT_SUCCESS
        ),
        tap(({}) => {
          //this.toastr.success('Visitor Checkout Success');
          this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  PreApprovedVisitorCheckoutFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.PreApprovedVisitorCheckoutFailure>(
          fromDashboardActions.DashboardActionTypes
            .PRE_APPROVED_VISITOR_CHECKOUT_FAILURE
        ),
        tap(({}) => {
          this.toastr.error('Visitor Checkout Failed');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  UpdateVisitorIdDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateVisitorIdDetail>(
        fromDashboardActions.DashboardActionTypes.UPDATE_VISITOR_ID_DETAIL
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.getVisitorData(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.UpdateVisitorIdDetailSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateVisitorIdDetailFailure(err))
          )
        );
      })
    )
  );
  SendReportsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SendReportsData>(
        fromDashboardActions.DashboardActionTypes.SEND_REPORTS_DATA
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      tap(({ action: { payload } }) => {
        const data = {
          isSending: true,
          isSuccess: false,
        };
        this.dialog.open(SendReportsEmailDialogComponent, {
          disableClose: true,
          data: data,
        });
      }),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onSendReportsData(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SendReportsDataSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SendReportsDataFailure(err))
          )
        );
      })
    )
  );
  SendReportsDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SendReportsDataSuccess>(
          fromDashboardActions.DashboardActionTypes.SEND_REPORTS_DATA_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          const data = {
            isSending: false,
            isSuccess: true,
          };
          this.dialog.open(SendReportsEmailDialogComponent, {
            disableClose: true,
            data: data,
          });
        })
      ),
    { dispatch: false }
  );
  SendReportsDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SendReportsDataFailure>(
          fromDashboardActions.DashboardActionTypes.SEND_REPORTS_DATA_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Error encountered');
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  FetchEmployees$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.FetchEmployees>(
        fromDashboardActions.DashboardActionTypes.FETCH_EMPLOYEES
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      // tap(({ action: { payload } }) => {
      //   const data = {
      //     isSending: true,
      //     isSuccess: false,
      //   };
      //   this.dialog.open(SendReportsEmailDialogComponent, {
      //     disableClose: true,
      //     data: data,
      //   });
      // }),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetEmployees().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.FetchEmployeesSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.FetchEmployeesFailure(err))
          )
        );
      })
    )
  );
  UpdateEmployees$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateEmployees>(
        fromDashboardActions.DashboardActionTypes.UPDATE_EMPLOYEES
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onUpdateEmployees(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.UpdateEmployeesSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateEmployeesFailure(err))
          )
        );
      })
    )
  );
  LogEmployeeAttendance$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.LogEmployeeAttendance>(
        fromDashboardActions.DashboardActionTypes.LOG_EMPLOYEE_ATTENDANCE
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onLogEmployeeAttendance(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.LogEmployeeAttendanceSuccess(payload)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.LogEmployeeAttendanceFailure(err))
          )
        );
      })
    )
  );
  checkWhetherValidLogDate(val: any) {
    let matchedEmployee: any = {
      employeeName: val.firstName + ' ' + val.lastName,
      employeeProfile: val.profilePictureLink,
      employeeId: val.employeeId,
      employeeNumber: val.phoneNumber,
      employeeAttendance: val.employeeAttendance,
    };
    const employeeAttendance: employeeAttendance[] = val.employeeAttendance;
    const sortedEmployeeAttendanceLogs = [...employeeAttendance].sort(
      (a, b) => {
        const dateA = new Date(a.logDate);
        const dateB = new Date(b.logDate);
        return dateB.getTime() - dateA.getTime();
      }
    );
    const latestLog: employeeAttendance = sortedEmployeeAttendanceLogs[0];
    const todayDate = new Date();
    const logDate = new Date(latestLog.logDate);
    const isTodayDate = logDate.toDateString() === todayDate.toDateString();

    const sortedEmployeeAttendance: EmployeeLogDetails[] = [
      ...latestLog.employeeLogDetails,
    ].sort((a, b) => b.logIndex - a.logIndex);
    const latestAttendanceLog: EmployeeLogDetails = sortedEmployeeAttendance[0];
    const logOutDate = new Date(latestAttendanceLog.logOutDate);
    const isTodayLogOut =
      logOutDate.toISOString() === '0000-12-31T18:06:32.000Z';
    if (latestLog.status == 1 && isTodayDate && isTodayLogOut) {
      matchedEmployee = {
        ...matchedEmployee,
        isCheckOut: true,
        isCheckIn: false,
        isMultiple: false,
      };
    } else {
      if (isTodayDate) {
        matchedEmployee = {
          ...matchedEmployee,
          isMultiple: true,
          isCheckOut: false,
          isCheckIn: false,
        };
      } else {
        matchedEmployee = {
          ...matchedEmployee,
          isCheckIn: true,
          isMultiple: false,
          isCheckOut: false,
        };
      }
    }
    this.dialog.open(EmployeeAttendanceResponseDialogComponent, {
      data: matchedEmployee,
    });
  }
  LogEmployeeAttendanceFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.LogEmployeeAttendanceFailure>(
          fromDashboardActions.DashboardActionTypes
            .LOG_EMPLOYEE_ATTENDANCE_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.error('Failed', 'Employee Attendance', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          // this.dialog.closeAll();
          // this.store.dispatch(new fromDashboardActions.FetchEmployees({}));
        })
      ),
    { dispatch: false }
  );
  LogEmployeeAttendanceSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.LogEmployeeAttendanceSuccess>(
          fromDashboardActions.DashboardActionTypes
            .LOG_EMPLOYEE_ATTENDANCE_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.toastr.success('Success', 'Employee Attendance', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.dialog.closeAll();
          if (payload?.isSelf) {
            this.checkWhetherValidLogDate(payload);
            setTimeout(() => {
              this.dialog.closeAll();
            }, 4000);
          }

          // this.store.dispatch(new fromDashboardActions.FetchEmployees({}));
        })
      ),
    { dispatch: false }
  );
  UpdateEmployeesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateEmployeesSuccess>(
          fromDashboardActions.DashboardActionTypes.UPDATE_EMPLOYEES_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.store.dispatch(new fromDashboardActions.FetchEmployees({}));
        })
      ),
    { dispatch: false }
  );
  SendQrWhatsapp$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SendQrWhatsapp>(
        fromDashboardActions.DashboardActionTypes.SEND_QR_WHATSAPP
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onSendEmployeeQR(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SendQrWhatsappSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SendQrWhatsappFailure(err))
          )
        );
      })
    )
  );
  SendQrWhatsappSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SendQrWhatsappSuccess>(
          fromDashboardActions.DashboardActionTypes.SEND_QR_WHATSAPP_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          if (payload === 'Employee Removed') {
            this.store.dispatch(new fromDashboardActions.FetchEmployees({}));
            this.dialog.closeAll();
            this.toastr.success('Removed', 'Employee', {
              closeButton: true,
              timeOut: 1500,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            });
          } else {
            this.toastr.success('QR Sent', 'Employee', {
              closeButton: true,
              timeOut: 1500,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            });
          }
        })
      ),
    { dispatch: false }
  );
  SearchNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SearchNumber>(
        fromDashboardActions.DashboardActionTypes.SEARCH_NUMBER
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onSearchNumber(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SearchNumberSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SearchNumberFailure(err))
          )
        );
      })
    )
  );
  SaveOrgSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SaveOrgSettings>(
        fromDashboardActions.DashboardActionTypes.SAVE_ORG_SETTINGS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onSetOrganizationSetting(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SaveOrgSettingsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SaveOrgSettingsFailure(err))
          )
        );
      })
    )
  );
  SaveOrgSettingsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SaveOrgSettingsSuccess>(
          fromDashboardActions.DashboardActionTypes.SAVE_ORG_SETTINGS_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('Saved', 'Org Setting', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.GetOrgSettings({}));
        })
      ),
    { dispatch: false }
  );
  GetOrgSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetOrgSettings>(
        fromDashboardActions.DashboardActionTypes.GET_ORG_SETTINGS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: {} }) => {
        return this.dashboardService.onGetOrgSettings().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetOrgSettingsSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetOrgSettingsFailure(err))
          )
        );
      })
    )
  );
  ManageVisitorPass$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.ManageVisitorPass>(
        fromDashboardActions.DashboardActionTypes.MANAGE_VISITOR_PASS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onManageVisitor(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.ManageVisitorPassSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.ManageVisitorPassFailure(err))
          )
        );
      })
    )
  );
  ManageVisitorPassSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ManageVisitorPassSuccess>(
          fromDashboardActions.DashboardActionTypes.MANAGE_VISITOR_PASS_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.success('Validity Saved', 'Visitor', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
        })
      ),
    { dispatch: false }
  );
  ManageVisitorPassFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ManageVisitorPassFailure>(
          fromDashboardActions.DashboardActionTypes.MANAGE_VISITOR_PASS_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.error('Error', 'Please try again!', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
        })
      ),
    { dispatch: false }
  );
  SaveUserInventory$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SaveUserInventory>(
        fromDashboardActions.DashboardActionTypes.SAVE_USER_INVENTORY
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onSaveUserInventory(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SaveUserInventorySuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SaveUserInventoryFailure(err))
          )
        );
      })
    )
  );
  SaveUserInventorySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SaveUserInventorySuccess>(
          fromDashboardActions.DashboardActionTypes.SAVE_USER_INVENTORY_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('List Saved', 'My List', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.dialog.closeAll();
          this.store.dispatch(new fromDashboardActions.GetUserInventory({}));
        })
      ),
    { dispatch: false }
  );
  GetUserInventory$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetUserInventory>(
        fromDashboardActions.DashboardActionTypes.GET_USER_INVENTORY
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({}) => {
        return this.dashboardService.onGetUserInventory().pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.GetUserInventorySuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetUserInventoryFailure(err))
          )
        );
      })
    )
  );
  RequestSOS$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.RequestSOS>(
        fromDashboardActions.DashboardActionTypes.REQUEST_SOS
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAdvancedSOSState,
        action: action,
      })),
      switchMap((data: any) => {
        let {
          action: {
            payload: {
              currentLocation: { longitude, latitude },
              requestId,
            },
          },
        } = data;
        const currentLocation = {
          latitude: latitude,
          longitude: longitude,
          requestId: requestId,
        };
        return this.dashboardService.onRequest(currentLocation).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.RequestSOSSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.RequestSOSFailed(err))
          )
        );
      })
    )
  );
  RequestSOSSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RequestSOSSuccess>(
          fromDashboardActions.DashboardActionTypes.REQUEST_SOS_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAdvancedSOSState,
          action: action,
        })),
        tap((data) => {
          this.store.dispatch(
            new fromAdvancedSoSActions.GetAdvancedSOSRequestsResponds({})
          );
          // this.toastr.success('Request Raised', 'AumYe Emergency', {
          //   closeButton: true,
          //   timeOut: 2000,
          //   progressBar: true,
          //   enableHtml: true,
          //   tapToDismiss: true,
          // });
          this.dialog.closeAll();
          // window.location.reload();
        })
      ),
    { dispatch: false }
  );
  RequestSOSFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RequestSOSFailed>(
          fromDashboardActions.DashboardActionTypes.REQUEST_SOS_FAILED
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeAdvancedSOSState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.dialog.closeAll();
          if (payload.status == 400) {
            this.toastr.warning('Request already raised', 'AumYe Emergency', {
              closeButton: true,
              timeOut: 5000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            });
          }
        })
      ),
    { dispatch: false }
  );
  GetComplaintsTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetComplaintsTickets>(
        fromDashboardActions.DashboardActionTypes.GET_COMPLAINTS_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.dashboardService.onGetComplaintsTickets().pipe(
          mergeMap((res: any) => {
            const encryptedData = lowerCaseFirstLetterOfKeys(
              this.encryptionService.decrypt(res.res)
            );
            return of(
              new fromDashboardActions.GetComplaintsTicketsSuccess(
                encryptedData
              )
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetComplaintsTicketsFailure(err))
          )
        );
      })
    )
  );
  //Claims
  GetClaimTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetClaimTickets>(
        fromDashboardActions.DashboardActionTypes.GET_CLAIM_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.dashboardService.onGetClaimTickets().pipe(
          mergeMap((res: any) => {
            const encryptedData = lowerCaseFirstLetterOfKeys(
              this.encryptionService.decrypt(res.res)
            );
            return of(
              new fromDashboardActions.GetClaimTicketsSuccess(encryptedData)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetClaimTicketsFailed(err))
          )
        );
      })
    )
  );
  //Requests
  GetRequestsTickets$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetRequestsTickets>(
        fromDashboardActions.DashboardActionTypes.GET_REQUESTS_TICKET
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap((data: any) => {
        return this.dashboardService.onGetRequestTickets().pipe(
          mergeMap((res: any) => {
            const encryptedData = lowerCaseFirstLetterOfKeys(
              this.encryptionService.decrypt(res.res)
            );
            return of(
              new fromDashboardActions.GetRequestsTicketsSuccess(encryptedData)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetRequestsTicketsFailed(err))
          )
        );
      })
    )
  );
  GetRangedRequestsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.GetRangedRequestsData>(
        fromDashboardActions.DashboardActionTypes.GET_RANGED_REQUEST_DATA
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeAnalyticsState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetRangedServiceTabData(payload).pipe(
          mergeMap((res: any) => {
            const data = {
              payload: payload,
              res: res,
            };
            return of(
              new fromDashboardActions.GetRangedRequestsDataSuccess(data)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.GetRangedRequestsDataFailure(err))
          )
        );
      })
    )
  );
  GetRangedRequestsDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetRangedRequestsDataFailure>(
          fromDashboardActions.DashboardActionTypes
            .GET_RANGED_REQUEST_DATA_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
        })
      ),
    { dispatch: false }
  );
  RequestsDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.GetRangedRequestsDataSuccess>(
          fromDashboardActions.DashboardActionTypes
            .GET_RANGED_REQUEST_DATA_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.success('Success', 'Service Request', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
  ClusterPreApprovedVisitor$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.ClusterPreApprovedVisitor>(
        fromDashboardActions.DashboardActionTypes.CLUSTER_PREAPPROVED_VISITOR
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap((data) => {
        let {
          action: { payload },
        } = data;
        return this.dashboardService.onClusterPreApproved(payload).pipe(
          mergeMap((res: any) => {
            return of(
              new fromDashboardActions.ClusterPreApprovedVisitorSuccess(res)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.CreateManualIncidentFailure(err))
          )
        );
      })
    )
  );
  ClusterPreApprovedVisitorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.ClusterPreApprovedVisitorSuccess>(
          fromDashboardActions.DashboardActionTypes
            .CLUSTER_PREAPPROVED_VISITOR_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.toastr.success('Success', 'Visitor Clustered', {
            closeButton: true,
            timeOut: 1500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
        })
      ),
    { dispatch: false }
  );
  SaveAppToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.SaveAppToken>(
        fromDashboardActions.DashboardActionTypes.SAVE_APP_TOKEN
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(() => {
        let token =
          Capacitor.getPlatform() === 'android'
            ? localStorage.getItem('App_Token')
            : localStorage.getItem('Web_Token');
        return this.dashboardService.onSaveAppToken(token).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.SaveAppTokenSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.SaveAppTokenFailed(err))
          )
        );
      })
    )
  );
  SaveAppTokenSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SaveAppTokenSuccess>(
          fromDashboardActions.DashboardActionTypes.SAVE_APP_TOKEN_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // this.dialog.closeAll();
          // this.toastr.info('Token Registered', 'Push Notification', {
          //   closeButton: true,
          //   timeOut: 2500,
          //   progressBar: true,
          //   enableHtml: true,
          //   tapToDismiss: true,
          // });
        })
      ),
    { dispatch: false }
  );
  SaveAppTokenFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SaveAppTokenFailed>(
          fromDashboardActions.DashboardActionTypes.SAVE_APP_TOKEN_FAILURE
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.info(
            'Grant notification permission',
            'Push Notification',
            {
              closeButton: true,
              timeOut: 2500,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            }
          );

          this.store.dispatch(new fromDashboardActions.FetchEmployees({}));
        })
      ),
    { dispatch: false }
  );

  RemoveAppToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.RemoveAppToken>(
        fromDashboardActions.DashboardActionTypes.REMOVE_APP_TOKEN
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: payload }) => {
        let token;
        const getDeviceToken = () => {
          const token =
            Capacitor.getPlatform() === 'android'
              ? localStorage.getItem('App_Token')
              : localStorage.getItem('Web_Token');

          // If token exists, return it
          if (token && token.trim() !== '') return token;

          // If missing → return sessionToken
          const sessionToken = localStorage.getItem('AccessToken');
          return sessionToken || undefined;
        };
        if (payload) {
          token = {
            userId: payload.payload.userId,
            orgId: payload.payload.orgId,
            userName: payload.payload.userName,
            deviceToken: getDeviceToken(),
            sessionToken: localStorage.getItem('AccessToken'),
          };
        } else {
          token = {
            deviceToken: getDeviceToken(),
          };
        }

        return this.dashboardService.onRemoveAppToken(token).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.RemoveAppTokenSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.RemoveAppTokenFailed(err))
          )
        );
      })
    )
  );
  RemoveAppTokenSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.RemoveAppTokenSuccess>(
          fromDashboardActions.DashboardActionTypes.REMOVE_APP_TOKEN_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          // this.encryptionService.logout();
          this.locationSosService.stopLocationTracking();
          this.aumyeFirebaseRealtimeDbService.deleteActiveUser();
          this.store.dispatch(new fromDashboardActions.ResetState({}));
          this.aumyeEmergencyLocationService.logOutUser();
          this.dialog.closeAll();
          setTimeout(() => {
            localStorage.clear();
            const deleteRequest = indexedDB.deleteDatabase('notifications-db');

            deleteRequest.onsuccess = () => {
              console.log('✅ notifications-db deleted successfully');
            };

            deleteRequest.onerror = (event) => {
              console.error('❌ Error deleting notifications-db:', event);
            };

            deleteRequest.onblocked = () => {
              console.warn(
                '⚠️ Deletion blocked — close other tabs using this DB'
              );
            };

            this.store.dispatch(
              new fromDashboardActions.RedirectingToLogin({})
            );
          }, 1000);
        })
      ),
    { dispatch: false }
  );
  AddUsersToEmployees$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddUsersToEmployees>(
        fromDashboardActions.DashboardActionTypes.ADD_USER_EMPLOYEES
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap((data) => {
        let {
          action: { payload },
        } = data;
        return this.dashboardService.onAddUsersToEmployees(payload).pipe(
          mergeMap((res: any) => {
            return of(new fromDashboardActions.AddUsersToEmployeesSuccess(res));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddUsersToEmployeesFailure(err))
          )
        );
      })
    )
  );
  AddUsersToEmployeesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddUsersToEmployeesSuccess>(
          fromDashboardActions.DashboardActionTypes.ADD_USER_EMPLOYEES_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {
          this.dialog.closeAll();
          this.toastr.success('Success', 'Registered Employees', {
            closeButton: true,
            timeOut: 2500,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });

          this.store.dispatch(new fromDashboardActions.FetchEmployees({}));
        })
      ),
    { dispatch: false }
  );

  SaveIncidentData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SaveIncidentData>(
          fromDashboardActions.DashboardActionTypes.SAVE_INCIDENT_DATA
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({}) => {})
      ),
    { dispatch: false }
  );

  SavePropertyData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.SavePropertyData>(
          fromDashboardActions.DashboardActionTypes.SAVE_PROPERTY_DATA
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          this.store.dispatch(
            new fromAssetsActions.LoadPropertyDataSuccess(payload)
          );
        })
      ),
    { dispatch: false }
  );
  UpdateVisitorById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateVisitorById>(
        fromDashboardActions.DashboardActionTypes.UPDATE_VISITOR_BY_ID
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetVisitorTabData().pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.UpdateVisitorByIdSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateVisitorByIdFailure(err))
          )
        );
      })
    )
  );
  UpdateVisitorByIdSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateVisitorByIdSuccess>(
          fromDashboardActions.DashboardActionTypes.UPDATE_VISITOR_BY_ID_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          if (message.MessageData != null) {
            const hostIds: string[] = JSON.parse(message.MessageData);
            if (this.userId == null) {
              window.alert('UserID is empty');
            }
            if (
              hostIds &&
              hostIds.some(
                (id) => id.toLowerCase() === this.userId.toLowerCase()
              )
            ) {
              this.toastr.success(
                message.MessageBody,
                message.FlowType === 'Comment'
                  ? 'Visitor: ' + message.MessageTitle
                  : message.MessageTitle,
                {
                  closeButton: true,
                  timeOut: 5000,
                  progressBar: true,
                  enableHtml: true,
                  tapToDismiss: true,
                }
              );
            }

            if (message.FlowType == 'Comment') {
              const userIds: string[] = JSON.parse(message.MessageData);
              userIds.forEach((userId) => {
                if (this.userId == userId) {
                  this.toastr.success(
                    'You have been mentioned in a comment on ' +
                      message.Id.split('-')[0],
                    'Comment Mention',
                    {
                      closeButton: true,
                      timeOut: 10000,
                      progressBar: true,
                      enableHtml: true,
                      tapToDismiss: true,
                    }
                  );
                }
              });
            }
          }
        })
      ),
    { dispatch: false }
  );
  UpdateIncidentById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateIncidentById>(
        fromDashboardActions.DashboardActionTypes.UPDATE_INCIDENT_BY_ID
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetIncidentById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.UpdateIncidentByIdSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateIncidentByIdFailure(err))
          )
        );
      })
    )
  );
  UpdateIncidentByIdSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateIncidentByIdSuccess>(
          fromDashboardActions.DashboardActionTypes
            .UPDATE_INCIDENT_BY_ID_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(
            message.MessageBody,
            message.FlowType === 'Comment'
              ? 'Incident: ' + message.MessageTitle
              : message.MessageTitle,
            {
              closeButton: true,
              timeOut: 10000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            }
          );
          if (message.MessageData != null) {
            if (message.FlowType == 'Comment') {
              const userIds: string[] = JSON.parse(message.MessageData);
              userIds.forEach((userId) => {
                if (this.userId == userId) {
                  this.toastr.success(
                    'You have been mentioned in a comment',
                    'Incident: ' + message.Id.split('-')[0],
                    {
                      closeButton: true,
                      timeOut: 10000,
                      progressBar: true,
                      enableHtml: true,
                      tapToDismiss: true,
                    }
                  );
                }
              });
            }
          }
        })
      ),
    { dispatch: false }
  );
  AddNewClaim$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddNewClaim>(
        fromDashboardActions.DashboardActionTypes.ADD_NEW_CLAIM
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetClaimById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.AddNewClaimSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddNewClaimFailure(err))
          )
        );
      })
    )
  );
  AddNewClaimSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddNewClaimSuccess>(
          fromDashboardActions.DashboardActionTypes.ADD_NEW_CLAIM_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(message.MessageBody, message.MessageTitle, {
            closeButton: true,
            timeOut: 10000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          if (message.MessageData != null) {
            const userIds: string[] = JSON.parse(message.MessageData);
            userIds.forEach((userId) => {
              if (this.userId == userId) {
                this.toastr.success(
                  'You have been assigned a new ' + message.MessageTitle,
                  'Assignee Info',
                  {
                    closeButton: true,
                    timeOut: 10000,
                    progressBar: true,
                    enableHtml: true,
                    tapToDismiss: true,
                  }
                );
              }
            });
          }
        })
      ),
    { dispatch: false }
  );
  AddNewRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddNewRequest>(
        fromDashboardActions.DashboardActionTypes.ADD_NEW_REQUEST
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetRequestById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.AddNewRequestSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddNewRequestFailure(err))
          )
        );
      })
    )
  );
  AddNewRequestSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddNewRequestSuccess>(
          fromDashboardActions.DashboardActionTypes.ADD_NEW_REQUEST_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(message.MessageBody, message.MessageTitle, {
            closeButton: true,
            timeOut: 10000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          if (message.MessageData != null) {
            const userIds: string[] = JSON.parse(message.MessageData);
            userIds.forEach((userId) => {
              if (this.userId.toLowerCase() == userId.toLowerCase()) {
                this.toastr.success(
                  'You have been assigned a new ' + message.MessageTitle,
                  'Assignee Info',
                  {
                    closeButton: true,
                    timeOut: 10000,
                    progressBar: true,
                    enableHtml: true,
                    tapToDismiss: true,
                  }
                );
              }
            });
          }
        })
      ),
    { dispatch: false }
  );
  AddNewComplaint$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddNewComplaint>(
        fromDashboardActions.DashboardActionTypes.ADD_NEW_COMPLAINT
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetComplaintById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.AddNewComplaintSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddNewComplaintFailure(err))
          )
        );
      })
    )
  );
  AddNewComplaintSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddNewComplaintSuccess>(
          fromDashboardActions.DashboardActionTypes.ADD_NEW_COMPLAINT_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(message.MessageBody, message.MessageTitle, {
            closeButton: true,
            timeOut: 10000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
          if (message.MessageData != null) {
            const userIds: string[] = JSON.parse(message.MessageData);
            userIds.forEach((userId) => {
              if (this.userId == userId) {
                this.toastr.success(
                  'You have been assigned a new ' + message.MessageTitle,
                  'Assignee Info',
                  {
                    closeButton: true,
                    timeOut: 10000,
                    progressBar: true,
                    enableHtml: true,
                    tapToDismiss: true,
                  }
                );
              }
            });
          }
        })
      ),
    { dispatch: false }
  );
  AddNewIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddNewIncident>(
        fromDashboardActions.DashboardActionTypes.ADD_NEW_INCIDENT
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetIncidentById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.AddNewIncidentSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddNewIncidentFailure(err))
          )
        );
      })
    )
  );
  AddNewIncidentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddNewIncidentSuccess>(
          fromDashboardActions.DashboardActionTypes.ADD_NEW_INCIDENT_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          if (message.FlowType != 'Request SOS') {
            this.toastr.success(message.MessageBody, message.MessageTitle, {
              closeButton: true,
              timeOut: 10000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            });
          }

          if (message.MessageData != null) {
            if (message.FlowType == 'New Incident') {
              const userIds: string[] = JSON.parse(message.MessageData);
              userIds.forEach((userId) => {
                if (this.userId == userId) {
                  this.toastr.success(
                    'You have been assigned a incident',
                    'Assignee Info',
                    {
                      closeButton: true,
                      timeOut: 10000,
                      progressBar: true,
                      enableHtml: true,
                      tapToDismiss: true,
                    }
                  );
                }
              });
            }
          }
        })
      ),
    { dispatch: false }
  );
  UpdateRequestById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateRequestById>(
        fromDashboardActions.DashboardActionTypes.UPDATE_REQUEST_BY_ID
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetRequestById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.UpdateRequestByIdSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateRequestByIdFailure(err))
          )
        );
      })
    )
  );
  UpdateClaimById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateClaimById>(
        fromDashboardActions.DashboardActionTypes.UPDATE_CLAIM_BY_ID
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetClaimById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.UpdateClaimByIdSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateClaimByIdFailure(err))
          )
        );
      })
    )
  );
  UpdateComplaintById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateComplaintById>(
        fromDashboardActions.DashboardActionTypes.UPDATE_COMPLAINT_BY_ID
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetComplaintById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(
              new fromDashboardActions.UpdateComplaintByIdSuccess(data)
            );
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.UpdateComplaintByIdFailure(err))
          )
        );
      })
    )
  );
  UpdateComplaintByIdSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateComplaintByIdSuccess>(
          fromDashboardActions.DashboardActionTypes
            .UPDATE_COMPLAINT_BY_ID_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(
            message.MessageBody,
            message.FlowType === 'Comment'
              ? 'Complaint: ' + message.MessageTitle
              : message.MessageTitle,
            {
              closeButton: true,
              timeOut: 10000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            }
          );
          if (message.MessageData != null) {
            if (message.FlowType == 'Comment') {
              const userIds: string[] = JSON.parse(message.MessageData);
              userIds.forEach((userId) => {
                if (this.userId == userId) {
                  this.toastr.success(
                    'You have been mentioned in a comment',
                    'Complaint: ' + message.Id.split('-')[0],
                    {
                      closeButton: true,
                      timeOut: 10000,
                      progressBar: true,
                      enableHtml: true,
                      tapToDismiss: true,
                    }
                  );
                }
              });
            }
          }
        })
      ),
    { dispatch: false }
  );
  UpdateClaimByIdSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateClaimByIdSuccess>(
          fromDashboardActions.DashboardActionTypes.UPDATE_CLAIM_BY_ID_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(
            message.MessageBody,
            message.FlowType === 'Comment'
              ? 'Claims: ' + message.MessageTitle
              : message.MessageTitle,
            {
              closeButton: true,
              timeOut: 10000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            }
          );
          if (message.MessageData != null) {
            if (message.FlowType == 'Comment') {
              const userIds: string[] = JSON.parse(message.MessageData);
              userIds.forEach((userId) => {
                if (this.userId == userId) {
                  this.toastr.success(
                    'You have been mentioned in a comment',
                    'Claims: ' + message.Id.split('-')[0],
                    {
                      closeButton: true,
                      timeOut: 10000,
                      progressBar: true,
                      enableHtml: true,
                      tapToDismiss: true,
                    }
                  );
                }
              });
            }
          }
        })
      ),
    { dispatch: false }
  );
  UpdateRequestByIdSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.UpdateRequestByIdSuccess>(
          fromDashboardActions.DashboardActionTypes.UPDATE_REQUEST_BY_ID_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(
            message.MessageBody,
            message.FlowType === 'Comment'
              ? 'Request: ' + message.MessageTitle
              : message.MessageTitle,
            {
              closeButton: true,
              timeOut: 10000,
              progressBar: true,
              enableHtml: true,
              tapToDismiss: true,
            }
          );
          if (message.MessageData != null) {
            if (message.FlowType == 'Comment') {
              const userIds: string[] = JSON.parse(message.MessageData);
              userIds.forEach((userId) => {
                if (this.userId == userId) {
                  this.toastr.success(
                    'You have been mentioned in a comment',
                    'Request: ' + message.Id.split('-')[0],
                    {
                      closeButton: true,
                      timeOut: 10000,
                      progressBar: true,
                      enableHtml: true,
                      tapToDismiss: true,
                    }
                  );
                }
              });
            }
          }
        })
      ),
    { dispatch: false }
  );
  UpdateEmployeeAttendanceById$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.UpdateEmployeeAttendanceById>(
        fromDashboardActions.DashboardActionTypes
          .UPDATE_EMPLOYEE_ATTENDANCE_BY_ID
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService
          .onGetEmployeeAttendanceById(payload.Id)
          .pipe(
            mergeMap((res: any) => {
              const data = {
                res: res,
                payload: payload,
              };
              return of(
                new fromDashboardActions.UpdateEmployeeAttendanceByIdSuccess(
                  data
                )
              );
            }),
            catchError((err: any) =>
              of(
                new fromDashboardActions.UpdateEmployeeAttendanceByIdFailure(
                  err
                )
              )
            )
          );
      })
    )
  );
  AddNewUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddNewUser>(
        fromDashboardActions.DashboardActionTypes.ADD_NEW_USER
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload }, state: { orgUserList } }) => {
        return this.dashboardService.onGetUserById(payload.Id).pipe(
          mergeMap((res: any) => {
            const updateUser = orgUserList.find(
              (user) => user.userId === payload.Id
            );
            const data = {
              res: res,
              payload: payload,
              previous: updateUser,
            };
            return of(new fromDashboardActions.AddNewUserSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddNewUserFailure(err))
          )
        );
      })
    )
  );
  AddNewUserSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddNewUserSuccess>(
          fromDashboardActions.DashboardActionTypes.ADD_NEW_USER_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload }, state: { orgUserList } }) => {
          const message = payload.payload;
          const isUpdateUser = orgUserList.find(
            (user) => user.userId === message.Id
          );
          if (isUpdateUser && this.userId === payload.res.userId) {
            const isRoleChanged =
              isUpdateUser.userRole.toLowerCase() !==
              payload.previous.userRole.toLowerCase();
            if (isRoleChanged) {
              this.toastr.success(
                'Your role has been changed, login again!',
                'User Update',
                {
                  closeButton: true,
                  timeOut: 5000,
                  progressBar: true,
                  enableHtml: true,
                  tapToDismiss: true,
                }
              );
              setTimeout(() => {
                this.store.dispatch(new fromDashboardActions.UserLogout({}));
              }, 5000);
            }
          }
          this.store.dispatch(new fromDashboardActions.GetUserList({}));
          this.store.dispatch(new fromManageUserActions.UserList({}));
          this.dialog.closeAll();
          this.toastr.success(message.MessageBody, message.MessageTitle, {
            closeButton: true,
            timeOut: 10000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );

  AddNewVisitor$ = createEffect(() =>
    this.actions$.pipe(
      ofType<fromDashboardActions.AddNewVisitor>(
        fromDashboardActions.DashboardActionTypes.ADD_NEW_VISITOR
      ),
      withLatestFrom(this.store, (action, state) => ({
        state: state.aumyeDashboardState,
        action: action,
      })),
      switchMap(({ action: { payload } }) => {
        return this.dashboardService.onGetVisitorById(payload.Id).pipe(
          mergeMap((res: any) => {
            const data = {
              res: res,
              payload: payload,
            };
            return of(new fromDashboardActions.AddNewVisitorSuccess(data));
          }),
          catchError((err: any) =>
            of(new fromDashboardActions.AddNewVisitorFailure(err))
          )
        );
      })
    )
  );
  AddNewVisitorSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<fromDashboardActions.AddNewVisitorSuccess>(
          fromDashboardActions.DashboardActionTypes.ADD_NEW_VISITOR_SUCCESS
        ),
        withLatestFrom(this.store, (action, state) => ({
          state: state.aumyeDashboardState,
          action: action,
        })),
        tap(({ action: { payload }, state: { orgUserList } }) => {
          const message = payload.payload;
          this.dialog.closeAll();
          this.toastr.success(message.MessageBody, message.MessageTitle, {
            closeButton: true,
            timeOut: 10000,
            progressBar: true,
            enableHtml: true,
            tapToDismiss: true,
          });
        })
      ),
    { dispatch: false }
  );
}

interface employeeAttendance {
  attendanceLogId: string;
  employeeLogDetails: EmployeeLogDetails[];
  logDate: Date;
  logDay: string;
  status: number;
}
interface EmployeeLogDetails {
  logIndex: number;
  logInDate: Date;
  logOutDate: Date;
  logDifference: number;
}

function lowerCaseFirstLetterOfKeys(data: any): any {
  if (Array.isArray(data)) {
    return data.map((item) => lowerCaseFirstLetterOfKeys(item));
  } else if (typeof data === 'object' && data !== null) {
    return Object.keys(data).reduce((acc: any, key: string) => {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      acc[newKey] = lowerCaseFirstLetterOfKeys(data[key]); // 🔁 recursively handle nested objects/arrays
      return acc;
    }, {});
  }
  return data; // primitive value
}
